/**
 * Theme Hook
 *
 * Wrapper around theme store for convenient access
 */

import { useThemeStore } from '@/stores/themeStore';

export function useTheme() {
  return useThemeStore();
}
